export default __webpack_public_path__ + "static/media/heavy_machinery_service_centers.185b4839.png";